module.exports = __webpack_public_path__ + "img4.e3ff18e.png";